const traducoes = {
  traducoes: {
    slugs: {
      menu: 'menu',
      sobreAFeira: 'sobre-a-feira',
      sicc: 'sicc',
      gramado: 'gramado',
      novoHamburgo: 'novo-hamburgo',
      fenac: 'Fenac',
      serraPark: 'serra-park',
      parceiros: 'parceiros',
      grupoDeImportadores: 'grupo-de-importadores',
      estacao3: 'estacao-3',
      conectech: 'conectech',
      queroVisitar: 'quero-visitar',
      hospedagem: 'hospedagem',
      traslado: 'traslado',
      credenciamento: 'credenciamento',
      agenciaDeTurismo: 'agencia-de-turismo',
      expositores: 'expositores',
      expositoresCategoriaFeminino: 'calcados-femininos',
      expositoresCategoriaMasculino: 'calcados-masculinos',
      expositoresCategoriaInfantil: 'calcados-infantis',
      expositoresCategoriaBolsasAcessorios: 'bolsas-e-acessorios',
      expositoresCategoriaEsportivos: 'calcados-esportivos',
      plantaBaixa: 'planta-baixa',
      eMerkator: 'e-merkator',
      eMerkatorTalks: 'e-merkator-talks',
      eMerkatorBlog: 'e-merkator-blog',
      eMerkatorTV: 'e-merkator-tv',
      eMerkatorCast: 'e-merkator-cast',
      eMerkatorPush: 'e-merkator-push',
      imprensa: 'imprensa',
      noticias: 'noticias',
      galeriaDeImagens: 'galeria-de-imagens',
      contato: 'contato',
      programacoes: 'emerkatortalks',
      onnoPlace: 'onno-place',
      cupomBeneficios: 'cupom-beneficios',
    },
    cabecalho: {
      painelExpositor: 'Painel Expositor',
      menu: 'Menu',
      sobreAFeira: 'Sobre a Feira',
      sicc: 'SICC',
      gramado: 'Gramado',
      novoHamburgo: 'Novo Hamburgo',
      fenac: 'Fenac',
      serraPark: 'Serra Park',
      parceiros: 'Parceiros',
      grupoDeImportadores: 'Grupo de Importadores',
      estacao3: 'Estação 3',
      conectech: 'Conectech',
      queroVisitar: 'Quero Visitar',
      hospedagem: 'Hospedagem',
      traslado: 'Traslado',
      credenciamento: 'Credenciamento',
      agenciaDeTurismo: 'Agência de Turismo',
      expositores: 'Expositores',
      plantaBaixa: 'Planta Baixa',
      eMerkator: 'eMerkator',
      eMerkatorTalks: 'eMerkator Talks',
      eMerkatorBlog: 'eMerkator Blog',
      eMerkatorTV: 'eMerkator TV',
      eMerkatorCast: 'eMerkator Cast',
      eMerkatorPush: 'eMerkator Push',
      imprensa: 'Imprensa',
      noticias: 'Notícias',
      galeriaDeImagens: 'Galeria de Imagens',
      contato: 'Contato',
      onnoPlace: 'ONNO place',
    },
    paginas: {
      inicial: {
        secaoSicc: {
          titulo: 'SICC - Salão Internacional do Couro e Calçado',
          subTitulo: 'A nova cara da moda',
          botaoQueroVisitar: 'Quero visitar',
          botaoGaleria: 'Galeria',
          conteudo:
            '<p>Promovido pela Merkator Feiras e Eventos, o SICC &ndash; Sal&atilde;o Internacional do Couro e do Cal&ccedil;ado &eacute; a principal plataforma lan&ccedil;adora da moda primavera / ver&atilde;o em cal&ccedil;ados e acess&oacute;rios, promovendo com qualifica&ccedil;&atilde;o o encontro anual da ind&uacute;stria cal&ccedil;adista com o varejo nacional e internacional. A feira cresce exponencialmente a cada ano e est&aacute; ancorada nos tr&ecirc;s principais pilares estrat&eacute;gicos, que norteiam e sustentam as a&ccedil;&otilde;es de sua promotora: turismo, neg&oacute;cio e informa&ccedil;&atilde;o.</p><p>Alian&ccedil;as estrat&eacute;gicas contribu&iacute;ram significativamente ao longo dos anos para a consolida&ccedil;&atilde;o da feira, que se compromete cada vez mais em buscar melhores solu&ccedil;&otilde;es &agrave; ind&uacute;stria e varejo, auxiliando nas transforma&ccedil;&otilde;es mercadol&oacute;gicas e entregando resultados.</p><p>SEJA MUITO BEM VINDO A NOVA CARA DA MODA</p>',
        },
        secaoGramado: {
          titulo: 'Gramado',
          conteudo:
            '<p>A cidade de Gramado/RS est&aacute; entre os mais charmosos e aconchegantes pontos tur&iacute;sticos da Serra Ga&uacute;cha. A arquitetura, inspirada em estilos europeus, &eacute; presen&ccedil;a marcante nos hot&eacute;is, museus, lojas e casas. Encanta, tamb&eacute;m, o urbanismo, o cuidado com a natureza, as ruas floridas, as tradicionais hort&ecirc;nsias e o verde exuberante das mais variadas esp&eacute;cies de &aacute;rvores.</p><p>Durante todo o ano, o glamour toma conta da regi&atilde;o, e pode-se aproveitar para conhecer as f&aacute;bricas de chocolate localizadas l&aacute; ou, at&eacute; mesmo, dar um passeio pelos museus, como o Museu dos Perfumes ou o Museu da Moda, este, em Canela, uma cidade vizinha e tamb&eacute;m repleta de atrativos. Al&eacute;m disso, outra boa dica &eacute; visitar o Lago Negro, com &aacute;rvores importadas da Floresta Negra da Alemanha.</p><p>Distante apenas 115 quil&ocirc;metros da capital Porto Alegre, os caminhos que levam at&eacute; Gramado s&atilde;o repletos de rotas tur&iacute;sticas, com extensas planta&ccedil;&otilde;es de pl&aacute;tanos. Conta tamb&eacute;m com a maior infra-estrutura tur&iacute;stica do Rio Grande do Sul, com dois grandes centros de feiras e eventos, uma ampla rede hoteleira e uma rede gastron&ocirc;mica que garante um atendimento simult&acirc;neo de 15 mil pessoas. Acesse aqui (www.gramado.rs.gov.br) e conhe&ccedil;a mais sobre a cidade.</p>',
          cupomDesconto: 'Cupom de benefícios',
        },
        secaoSerraPark: {
          titulo: 'Serra Park',
          subTitulo: 'Viação Férrea, nº 100, Gramado/RS',
          conteudo:
            '<p>O SICC acontece no mais belo local de exposi&ccedil;&otilde;es do estado do Rio Grande do Sul, o Serra Park. Localizado na cidade de Gramado - um dos principais destinos tur&iacute;sticos do Pa&iacute;s - o Serra Park est&aacute; hoje entre as melhores e mais confort&aacute;veis estruturas para promo&ccedil;&atilde;o de eventos do sul do Brasil.</p><p>Instalado em meio a 460 mil m&sup2; de &aacute;rea natural, o local possui todos os requisitos para um evento de sucesso, com infra-estrutura completa, amplo estacionamento, localiza&ccedil;&atilde;o privilegiada no principal acesso da cidade e uma inesquec&iacute;vel vista do Vale do Quilombo. Este &eacute; o local ideal para reunir empres&aacute;rios, promover rodadas de neg&oacute;cios e estimular o crescimento econ&ocirc;mico de segmentos industriais.</p>',
          tituloCaracteristicas: 'Características',
          caracteristicas:
            '<p>&Aacute;rea coberta: 28 mil m&sup2;<br />&Aacute;rea total: 460 mil m&sup2;<br />Estacionamento para 3 mil ve&iacute;culos<br />Piso em concreto estruturado, liso e nivelado<br />P&eacute; direito lateral de 8 m<br />Central telef&ocirc;nica para 200 ramais<br />2,3 mil KVA de energia el&eacute;trica<br />Ar comprimido<br />Sala VIP<br />Ampla pra&ccedil;a de alimenta&ccedil;&atilde;o<br />Seguran&ccedil;a 24h<br />2 lagos<br />Reserva Ecol&oacute;gica<br />360&deg; de vista panor&acirc;mica num dos pontos mais altos de Gramado/RS</p>',
        },
        secaoParceiros: {
          titulo: 'Parceiros',
          conteudo:
            '<p>O crescente sucesso que o Sal&atilde;o Internacional do Couro e do Cal&ccedil;ado vem registrando tem uma receita pr&oacute;pria com tempero especial: o engajamento dos principais sindicatos industriais do pa&iacute;s. A forma&ccedil;&atilde;o de parcerias &eacute; uma das principais filosofias da Merkator Feiras e Eventos, empresa promotora do SICC.</p><p>Desde 2006, foi iniciada a forma&ccedil;&atilde;o de uma for&ccedil;a de apoio ao evento que resultou na participa&ccedil;&atilde;o das marcas mais significativas do cal&ccedil;ado brasileiro.</p><p>A primeira entidade que se uniu ao fortalecimento da feira foi o Sindicato das Ind&uacute;strias de Cal&ccedil;ados de Tr&ecirc;s Coroas, tendo logo a seguir a parceria dos sindicatos dos munic&iacute;pios de Igrejinha, Sapiranga, Novo Hamburgo, Parob&eacute;, Ivoti e Est&acirc;ncia Velha.</p>',
        },
        secaoGrupoDeImportadores: {
          titulo: 'Grupo de Importadores',
          conteudo:
            '<p>O Grupo de Importadores &eacute; um projeto de incentivo &agrave;s exporta&ccedil;&otilde;es de cal&ccedil;ados e acess&oacute;rios que cresce a cada ano e traz compradores de diferentes pa&iacute;ses e continentes. &Eacute; realizado pela Merkator junto com os sindicatos das ind&uacute;strias de cal&ccedil;ados parceiros. Com o cen&aacute;rio apontando para um incremento nos neg&oacute;cios com o exterior e a garantia de uma visita&ccedil;&atilde;o expressiva de compradores internacionais, fazer parte do Grupo de Importadores torna-se um neg&oacute;cio ainda mais atrativo.</p><p>Participe. Para mais informa&ccedil;&otilde;es, contate-nos.</p><p><strong>Michele Lovato</strong><br /><strong>Coordenadora do Grupo de Importadores</strong><br /><strong>+55 (54) 3286 5033</strong><br /><strong>importadores@sicc.com.br</strong></p>',
        },
        secaoEstacao3: {
          titulo: 'Estação 3',
          conteudo:
            '<p>Cosmopolita, moderna, din&acirc;mica e, ao mesmo tempo, cl&aacute;ssica. Assim &eacute; New York, um dos points mais badalados do mundo. Em 2019, a Esta&ccedil;&atilde;o 3, espa&ccedil;o conceitual da feira, se vestiu da cidade nova-iorquina e trouxe experi&ecirc;ncia , a&ccedil;&otilde;es diferenciadas e grandes marcas.</p><p>Em 2021, nosso pr&oacute;ximo destino &eacute; Paris, mon amour!</p>',
        },
        secaoConectech: {
          titulo: 'Conectech',
          conteudo:
            '<p>Conectando o varejo ao futuro. Um projeto Merkator + IBTeC + SetaDigital.<br />A informa&ccedil;&atilde;o &eacute; combustivel para fazer prosperar qualquer neg&oacute;cio. No<br />varejo ent&atilde;o, ela &eacute; fundamental. N&atilde;o basta mais saber o que est&aacute;<br />acontecendo. &Eacute; preciso saber o que vem por a&iacute;.</p><p>O ConecTech &eacute; um espa&ccedil;o localizado no M&oacute;dulo 4 dentro dos pavilh&otilde;es<br />do SICC. Foi criado para auxiliar o lojista a enxergar o mercado de forma<br />mais abrangente atrav&eacute;s de ferramentas, tecnologias, palestras e conex&otilde;es.</p><p>&Eacute; neste espa&ccedil;o que a M Store - Loja Inteligente mostra na pr&aacute;tica todas as<br />tecnologias que podem facilitar o dia a dia dos lojistas, ajudando a conhecer<br />mais o consumidor e seus h&aacute;bitos atrav&eacute;s de softwares de controle.</p>',
        },
        secaoQueroVisitar: {
          titulo: 'Quero visitar',
          hospedagem: {
            titulo: 'HOSPEDAGEM',
            conteudo:
              '<p>O SICC disponibilizar&aacute; cortesias de hospedagem em hot&eacute;is em Novo Hamburgo, durante o per&iacute;odo da feira. As cortesias s&atilde;o exclusivas para lojistas do setor cal&ccedil;adista.</p>',
            textoBotao: 'Solicitar aqui',
            textoEmBreve: 'Em breve',
            subTextoBotao: '',
          },
          translado: {
            titulo: 'COMO CHEGAR NO SICC',
            conteudo:
              '<pConfira abaixo as opções de transporte disponíveis para chegar até o evento: </p><p>Trem: Desembarque na Estação FENAC. A estação está localizada em frente ao local do evento, proporcionando acesso rápido e prático.</p><p>Carro de aplicativo (Uber/99): Corridas por aplicativos estão disponíveis na região e são uma alternativa conveniente.</p><p>Aluguel de carro: Há diversas locadoras de veículos que operam na região para quem prefere mais autonomia no deslocamento.</p><p>Veículo próprio: A FENAC conta com estacionamento no local (serviço pago à parte).</p>',
            textoBotao: 'Horários e valores aqui',
            textoEmBreve: 'Em breve',
            subTextoBotao: '',
          },
          credenciamento: {
            titulo: 'CREDENCIAMENTO',
            conteudo:
              '<p>O SICC quer facilitar a sua entrada na feira. Com este procedimento voc&ecirc; ter&aacute; um crach&aacute; pronto a sua espera no guich&ecirc; de Credenciamento Antecipado e poder&aacute; ingressar na feira para conhecer os principais lan&ccedil;amentos primavera-ver&atilde;o das ind&uacute;strias de cal&ccedil;ados e acess&oacute;rios do Brasil.</p>',
            textoBotao: 'Credencie-se aqui',
            textoEmBreve: 'Em breve',
            subTextoBotao:
              '<br>As solicitações web iniciarão no dia 06 de agosto de 2024',
          },
        },
        secaoAgenciaDeTurismo: {
          titulo: 'Agência de Turismo',
          conteudo:
            '<p>A Sunpower Turismo, &eacute; a ag&ecirc;ncia de viagens oficial da feira.</p><p>Possui uma equipe que conta com profissionais qualificados e experientes, prestando sempre um servi&ccedil;o de qualidade, personalizado, com foco na satisfa&ccedil;&atilde;o do cliente.</p><p>Oferecemos todos os servi&ccedil;os de log&iacute;stica de viagem com descontos especiais para os participantes/expositores da feira.</p><p>- Hospedagem;<br />- Passagem a&eacute;rea;<br />- Loca&ccedil;&atilde;o de carros.</p><p>Lembramos que as reservas solicitadas com anteced&ecirc;ncia garantem as melhores tarifas e condi&ccedil;&otilde;es!</p><p>Mais informa&ccedil;&otilde;es, seguem os nossos contatos:<br />Sunpower Turismo<br />+55 54-3286 5033<br />reservas@sunpowerturismo.com.br | www.sunpowerturismo.com.br</p>',
          subTitulo: 'Agência de Turismo Oficial',
        },
        secaoExpositores: {
          titulo: 'Expositores',
          subTitulo: 'Selecione o produto desejado:',
          subTituloBreve: 'Em breve mais informações.',
          categorias: {
            feminino: 'Feminino',
            masculino: 'Masculino',
            infantil: 'Infantil',
            acessorios: 'Bolsas, acessórios e artefatos de couro',
            esportivos: 'Esportivos',
          },
        },
        secaoPlantaDaFeira: {
          titulo: 'Planta da feira',
          description: 'Clique aqui para baixar a planta em PDF',
        },
        secaoEMerkator: {
          titulo: 'eMerkator',
          subTitulo: 'Conecta você ao mercado',
          textoLinkProgramacao: 'Programação completa',
        },
        secaoImprensa: {
          titulo: 'Imprensa',
          noticias: 'Notícias',
          galeriaDeImagens: 'Galeria de Imagens',
          falarComImprensa: 'Quero falar com a assessoria de imprensa',
        },
      },
      noticias: {
        secaoNoticias: {
          titulo: 'Notícias',
        },
      },
      noticia: {
        secaoNoticia: {
          titulo: 'Notícia',
          tituloNoticia:
            'Ano desafiador: promotora transita em ambientes virtual e presencial para realizar eventos antes e durante a pandemia  ',
          legendaImagem:
            'Frederico em coletiva na Zero Grau 2020 - Foto: Dinarci Borges',
          textoTags: 'TAGS',
          conteudo:
            '<p>Neste ano inusitado, poucas empresas conseguiram realizar suas tarefas. A Merkator Feiras e Eventos, promotora das maiores feiras do setor cal&ccedil;adista brasileiro, precisou ter maleabilidade para transitar em diversos ambientes, a fim de conseguir realizar seus tr&ecirc;s eventos programados para este 2020. Certamente foi uma exce&ccedil;&atilde;o. O resumo desta trajet&oacute;ria foi a capacidade da empresa em se adaptar rapidamente as restri&ccedil;&otilde;es impostas pela pandemia do Coronav&iacute;rus. Logo no in&iacute;cio do ano, no m&ecirc;s de fevereiro, promoveu a maior feira dos mercados Norte e Nordeste do pa&iacute;s com a realiza&ccedil;&atilde;o presencial da 40 Graus &ndash; Feira de Cal&ccedil;ados e Acess&oacute;rios, em Jo&atilde;o Pessoa (PB). Cerca de 150 dias depois, a Merkator lan&ccedil;a a primeira plataforma online de feiras no pa&iacute;s e em 07 de julho realiza o primeiro encontro virtual de neg&oacute;cios entre fabricantes e lojistas do setor. O SICC &ndash; Sal&atilde;o Internacional do Couro e do Cal&ccedil;ado foi o evento percursor dentro da realidade do distanciamento social, vivido por praticamente toda a humanidade no primeiro semestre deste ano. E, logo em seguida, quatro meses depois, no m&ecirc;s de novembro, a mesma promotora, realiza a primeira feira presencial ainda durante a pandemia, em Gramado (RS), com a edi&ccedil;&atilde;o da Zero Grau &ndash; Feira de Cal&ccedil;ados e Acess&oacute;rios, marcando a retomada nacional dos eventos setoriais.</p><p>- Tudo isto foi extremamente desafiador. N&atilde;o est&aacute;vamos preparados para nenhuma destas realidades. Todos os passos foram constru&iacute;dos diariamente, sempre com cuidado para poder contemplar a sa&uacute;de de todos os profissionais envolvidos e tamb&eacute;m a busca da sustenta&ccedil;&atilde;o dos neg&oacute;cios tanto da ind&uacute;stria como do varejo. Foi um quebra cabe&ccedil;a sem precedentes que procurou atender a demanda dos nossos clientes para iniciar mais fortemente o movimento da economia&rdquo;, diz Frederico Pletsch, diretor da Merkator Feiras e Eventos. Foi necess&aacute;ria uma mobilidade de pensamento e o encontro de personagens com o mesmo desejo. &ldquo;Foi ouvindo os nossos expositores que fomos buscar solu&ccedil;&otilde;es inovadoras, como a plataforma eMerkator para realizar o SICC e angariar for&ccedil;as para gestionar junto &agrave;s autoridades estaduais e tamb&eacute;m produzir protocolos in&eacute;ditos para fazer a Zero Grau presencial. Olhando para tr&aacute;s nem acredito numa situa&ccedil;&atilde;o desta, cada dia, cada semana era uma pauta nova para executar sem nenhum exemplo a seguir&rdquo;, lembra Pletsch. Ele acrescenta que foi muito dif&iacute;cil, &ldquo;mas conseguimos e estamos fechando o ano com saldo positivo e com a tranquilidade do dever cumprido, mesmo impactados emocionalmente por cada um destes acontecimentos&rdquo;.</p><p>E para encerrar este 2020, a Merkator anuncia nova mudan&ccedil;a. Transfere a pr&oacute;xima edi&ccedil;&atilde;o da 40 Graus &ndash; Feira de Cal&ccedil;ados e Acess&oacute;rios anteriormente marcada para o m&ecirc;s de fevereiro do pr&oacute;ximo ano para os dias 09, 10 e 11 de agosto de 2021, no Centro de Exposi&ccedil;&atilde;o de Jo&atilde;o Pessoa, na Para&iacute;ba. &ldquo;Esta &eacute; outra novidade que veio atrav&eacute;s de consultas junto aos fabricantes e aos lojistas. Ouvimos todos com muita aten&ccedil;&atilde;o e tomamos a decis&atilde;o de trocar a data para possibilitar um melhor abastecimento das lojas das regi&otilde;es norte e nordeste para a temporada mais quente assim como para as festas do final do ano&rdquo;, diz Pletsch. Salienta ainda que este desejo do mercado vem sendo expresso desde a &uacute;ltima edi&ccedil;&atilde;o da feira. &ldquo;Estamos ajustando um calend&aacute;rio baseado em reivindica&ccedil;&otilde;es do setor. Desejamos poder fazer um evento que d&ecirc; oportunidades para todo o mercado de cal&ccedil;adista&rdquo;, finaliza Pletsch.</p><p>Por: Divulga&ccedil;&atilde;o em: 14/12/2020 &agrave;s 14:50</p>',
        },
      },
      galerias: {
        titulo: 'Galerias',
      },
      programacoes: {
        secaoProgramacoes: {
          titulo: 'eMerkatorTalks',
          diasSemana: {
            0: 'Domingo',
            1: 'Segunda-feira',
            2: 'Terça-feira',
            3: 'Quarta-feira',
            4: 'Quinta-feira',
            5: 'Sexta-feira',
            6: 'Sabado',
          },
        },
      },
      programacao: {
        secaoProgramacao: {
          titulo: 'eMerkatorTalks',
        },
      },
      traslado: {
        titulo: 'Traslado',
        description:
          '<p>O Traslado Oficial do Aeroporto de Porto Alegre até os hotéis credenciados será realizado através do transporte oficial do SICC, operacionalizado pela empresa Brocker Turismo com objetivo de oferecer maior comodidade, conforto e segurança aos nossos visitantes.</p><p>A equipe da Merkator juntamente com a equipe Brocker Turismo, estará no terminal de desembarque, coordenando as saídas dos traslados até os respectivos hotéis.</p><p><b>Plantão de atendimento Traslado:</b><br> +55 54 99163-1410 (Whatsapp)<br/> +55 54 3282-5445 (Telefone Fixo - Atendimento Geral)<br/> eventos@brockerturismo.com.br</p>',
        textAlert: '<b>*Horários estimados.</b>',
        textAlert2:
          '<b>É OBRIGATÓRIO</b> o comparecimento do cliente no estande da Equipe do traslado para confirmar / ou agendar no horário do traslado de Gramado/Canela para Porto Alegre.<br />Para mais informações sobre o traslado e compra antecipada entre em contato pelo número: (51) 99651-5213, Com Catherine.',
        textTrasnporteOficial: 'Transporte Oficial',
        textBotaoComprar: 'Compre seu transfer aqui',
        textBotaoValores: 'Valores',
        textEventoDiaUm: 'Domingo 30/06',
        textEventoDiaDois: 'Segunda-feira 01/07',
        textEventoDiaTres: 'Terça-feira 02/07',
        textEventoDiaQuatro: 'Quarta-feira 03/07',
        textEventoDiaCinco: 'Quinta-feira 04/07',
        textTitleDescriptionDiaUm:
          'Saída do Aeroporto de Porto Alegre até os Hotéis conveniados da feira.',
        textDescriptionDiaUm:
          '(Desembarque nos hotéis)</p><p><b>10h | 12h | 14h | 16h | 18h | 20h *</b>',
        textTitleDescriptionDiaDois:
          'Aeroporto para Gramado/Canela (Desembarque na feira).',
        textDescriptionDiaDois: '<b>Horários: 8h | 10h | 12h | 14h *</b>',
        textTitleDescriptionDiaTres:
          'Aeroporto para o Serra Park (Desembarque na feira).',
        textTitleDescriptionDiaTresV:
          'Gramado para Aeroporto Salgado Filho (Embarque na feira)',
        textDescriptionDiaTres: '<b>8h | 10h | 12h | 14h *</b>',
        textDescriptionDiaTresV: '<b>14h</b>',
        textTitleDescriptionDiaQuatro:
          'Gramado para Aeroporto Salgado Filho (Embarque na feira).',
        textTitleDescriptionDiaQuatroV:
          'Gramado/Canela para Aeroporto Salgado Filho',
        textDescriptionDiaQuatro: '<b>10h | 12h | 14h | 16h *</b>',
        textDescriptionDiaQuatroV:
          '(Embarque na feira)<br /><br /><b>01h | 10h | 11h30min | 13h | 14h | 15h30min</b><br /><br />Todos os horários de retorno devem ser agendados previamente nos balcões de traslado oficial, na feira.',
        textTitleDescriptionDiaCinco:
          'Gramado para Aeroporto Salgado Filho (Embarque na feira).',
        textDescriptionDiaCinco: '<b>10h | 12h | 14h | 16h *</b>',
        titleTicketUnico: 'TICKET <br /> ÚNICO',
        titleDescriptionUnico:
          'Aeroporto (POA) para Gramado/Canela ou Gramado/Canela para Aeroporto (POA)',
        precoTicketUnico: 'R$100,00',
        comboTicketUnico: 'COMBO IDA E VOLTA',
        comboDescriptionUnico:
          'Aeroporto (POA) para Gramado/Canela e Gramado/Canela para Aeroporto (POA)',
        precoComboTicketUnico: 'R$260,00',
        titleTicketAvulso: 'COMBO<br />TICKET INTERNO',
        descriptionTicketAvulso:
          'Hotel para feira e Feira para hotel (todos os dias do evento)',
        precoTicketAvulso: 'R$100,00',
        titleComboFeira: 'TICKET<br />INTERNO',
        descriptionComboFeira:
          'Hotel credenciado para Serra Park e Serra Park para hotel credenciado',
        precoComboFeira: 'R$100,00',
        porPessoa: 'por pessoa',
        exceptionPrice: '',
        textCompreAqui: 'COMPRE AQUI SEU TRANSFER',
        descriptionValor:
          '<p><b>Adquirindo o combo (Aeroporto/POA > Gramado | Traslado Interno | Gramado > Aeroporto/POA) ou o ticket único de retorno antecipadamente a seu traslado de retorno já estará agendado e você não precisará fazer o agendamento na Feira.</b></p>',
      },
      expositores: {
        titulo: 'Expositores',
        botaoCategoria: {
          listaCompleta: 'Lista Completa',
          feminino: 'Feminino',
          masculino: 'Masculino',
          infantil: 'Infantil',
          acessorios: 'Bolsas, acessórios e artefatos de couro',
          esportivos: 'Esportivos',
        },
        inputPlaceholder: 'Encontre a marca desejada',
      },
      eMerkatorTv: {
        titulo: 'eMerkator TV',
      },
      pagina404: {
        titulo: 'Página não encontrada.',
      },
    },
    componentes: {
      painelExpositor: {
        email: 'E-mail',
        senha: 'Senha',
        entrar: 'Entrar',
        cancelar: 'Cancelar',
        esqueciMinhaSenha: 'Esqueci minha senha',
      },
      secao: {
        botaoVoltar: 'Voltar',
      },
      cabecalho: {
        linguagem: 'Linguagem',
        portugues: 'Português',
        ingles: 'Inglês',
        espanhol: 'Espanhol',
      },
      rodape: {
        baixeNossoApp: 'Baixe nosso app',
        disponivelNa: 'Disponível na',
      },
      secaoEMerkator: {
        programacaoCompleta: 'Programação completa',
        // programacaoCompleta: 'Em breve',
      },
    },
  },
};

export default traducoes;
